<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-9">
          <div class="element-wrapper" style="padding-bottom: 1rem">
            <div class="element-box">
              <div class="col-12">
                <!--router-link
                  class="btn btn-sm font-weight-bold text-success"
                  :to="{ name: 'cxc-cargos-fel' }"
                >
                  <i class="fa fa-arrow-left"></i>
                  Todos los Cargos Pendientes
                </router-link>-->
                <br />
              </div>
              <div class="col-12">
                <h5 class="text-dark">
                  CXC Cargo
                  <u>#{{ current.numero }}</u>
                  &nbsp;
                  <div
                    class="badge"
                    :class="{
                      'badge-success': current.estado == 'A',
                      'badge-warning': current.estado == 'B',
                      'badge-danger': current.estado == '9',
                      'badge-blue': current.estado == 'E',
                    }"
                  >
                    <i class="os-icon os-icon-ui-09"></i>
                    <span v-if="current.estado == 'A'">Abierto</span>
                    <span v-if="current.estado == 'B'">Cerrado</span>
                    <span v-if="current.estado == 'E'">Impreso</span>
                    <span v-if="current.estado == '9'">Anulado</span>
                    <span v-if="!current.estado">En Proceso</span>
                  </div>
                  <div class="st-meta float-right">
                    <div class="element-actions">
                      <div class="btn-group">
                        <button
                          aria-expanded="false"
                          aria-haspopup="true"
                          class="btn btn-secondary dropdown-toggle"
                          data-toggle="dropdown"
                          type="button"
                        >
                          <i class="fa fa-cogs"></i>
                          Acciones
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                          <button
                            class="dropdown-item"
                            :class="{ disabled: !(current.estado == 'B') }"
                            @click="abrir"
                            :disabled="!(current.estado == 'B')"
                            href="#"
                          >
                            <i class="fa fa-unlock"></i>
                            Abrir Operación
                          </button>
                          <button
                            class="dropdown-item"
                            @click="cerrar"
                            :disabled="!(current.estado == 'A')"
                            href="#"
                          >
                            <i class="fa fa-lock"></i>
                            Cerrar Operación
                          </button>
                          <button
                            class="dropdown-item"
                            @click="anular"
                            :disabled="
                              !(current.estado != '9' && current.estado != 'E')
                            "
                            href="#"
                          >
                            <i class="fa fa-archive"></i>
                            Anular Operación
                          </button>
                          <button
                            v-if="!current.uuid_fel"
                            class="dropdown-item"
                            @click="fel"
                            href="#"
                          >
                            <i class="fa fa-archive"></i>
                            Enviar Fel
                          </button>
                          <button
                            v-if="!current.uuid_fel"
                            class="dropdown-item"
                            @click="cerrerContabilizacion()"
                            href="#"
                          >
                            <i class="fa fa-check"></i>
                            Cerrar Contabilización
                          </button>
                          <button class="dropdown-item" @click="rowClick()">
                            &nbsp;<i class="fas fa-info"></i>&nbsp; Generar
                            Devolución
                          </button>
                          <div class="dropdown-divider"></div>
                        </div>
                        <hr />
                        &nbsp;&nbsp;&nbsp;
                      </div>
                      <div class="btn-group">
                        <div class="dropdown show">
                          <button
                            aria-expanded="false"
                            aria-haspopup="true"
                            class="btn btn-secondary dropdown-toggle"
                            data-toggle="dropdown"
                            type="button"
                          >
                            <i class="fa fa-print"></i>
                            Impresiones
                          </button>
                          <div
                            class="dropdown-menu"
                            aria-labelledby="impresionesDropdown"
                          >
                            <a
                              :href="
                                baseApiUrl +
                                '/cxc/cargos/factura/?carta=1&report_format=pdf&Id=' +
                                factura
                              "
                              class="dropdown-item"
                              target="_blank"
                            >
                              <i class="fas fa-file-pdf"></i>
                              Factura Carta
                            </a>
                            <a
                              :href="
                                baseApiUrl +
                                '/cxc/cargos/factura/?media_carta=1&report_format=pdf&Id=' +
                                factura
                              "
                              class="dropdown-item"
                              target="_blank"
                            >
                              <i class="fas fa-file-pdf"></i>
                              Factura Media Carta
                            </a>
                            <a
                              :href="
                                baseApiUrl +
                                '/cxc/cargos/factura/?report_format=pdf&Id=' +
                                factura
                              "
                              class="dropdown-item"
                              target="_blank"
                            >
                              <i class="fas fa-file-pdf"></i>
                              Factura Ticket
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </h5>
              </div>
              <br />
              <p class="text-danger" v-if="log_error && !mostrarCompleto">
                {{ descripcionCorta }}
                <a class="text-dark font-weight-bold" @click="mostrarCompleto = true">Ver más</a>
              </p>
              <p class="text-danger" v-if="log_error && mostrarCompleto">
                {{ log_error }}
                <a
                  class="text-dark font-weight-bold"
                  @click="mostrarCompleto = false"
                  >Ver menos</a
                >
              </p>
              <div class="row">
                <div class="col-4">
                  <div class="form-group">
                    <label>Nit</label>
                    <input
                      type="text"
                      v-model="current.cliente_nit"
                      class="form-control"
                      :disabled="true"
                    />
                  </div>
                </div>
                <div class="col-4">
                  <label>Cliente</label>
                  <input
                    :disabled="true"
                    class="form-control"
                    autofocus="autofocus"
                    v-model="current.cliente_nombre"
                    @input="$emit('input', $event.target.value)"
                  />
                </div>
                <div class="col-4">
                  <label>Direccion</label>
                  <input
                    :disabled="true"
                    class="form-control"
                    autofocus="autofocus"
                    v-model="current.cliente_direccion"
                    @input="$emit('input', $event.target.value)"
                  />
                </div>
                <div class="col-3">
                  <div class="form-group">
                    <label>Tienda</label>
                    <input
                      :disabled="true"
                      class="form-control"
                      v-model="current.local"
                    />
                  </div>
                </div>
                <div class="col-3">
                  <div class="form-group">
                    <label>Serie</label>

                    <input
                      :disabled="true"
                      class="form-control"
                      autofocus="autofocus"
                      v-model="current.cargo_serie"
                      @input="$emit('input', $event.target.value)"
                    />
                  </div>
                </div>
                <div class="col-3">
                  <div class="form-group">
                    <label>Cajero</label>
                    <input
                      :disabled="true"
                      class="form-control"
                      autofocus="autofocus"
                      v-model="current.despacho"
                      @input="$emit('input', $event.target.value)"
                    />
                  </div>
                </div>
                <div class="col-3">
                  <div class="form-group">
                    <label>Fecha creación</label>
                    <input
                      :disabled="true"
                      class="form-control"
                      autofocus="autofocus"
                      v-model="current.fecha_creacion"
                      @input="$emit('input', $event.target.value)"
                    />
                  </div>
                </div>
                <h6>Informaciónde FEL</h6>
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>UUI FEL</th>
                      <th>Serie FEL</th>
                      <th class="text-center">Numero FEL</th>
                      <th class="text-center">Numero Contigencia FEL</th>
                      <th class="text-center">Opciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ current.uuid_fel }}</td>
                      <td>{{ current.serie_fel }}</td>
                      <td>{{ current.numero_fel }}</td>
                      <td>{{ current.contingencia_fel }}</td>
                      <td width="15%">
                        <a
                          v-if="current.uuid_fel"
                          :href="
                            'https://report.feel.com.gt/ingfacereport/ingfacereport_documento?uuid=' +
                            current.uuid_fel +
                            '&formato=pdf&tipo_operacion=CERTIFICACION'
                          "
                          class="btn btn-sm btn-success"
                          target="_blank"
                        >
                          <i class="fas fa-file-pdf"></i> PDF Fel</a
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>

                <router-link
                  class="btn btn-dark"
                  :to="{ name: 'cxc-cargos-fel' }"
                >
                  <i class="fa fa-arrow-circle-left"></i>
                  Pendientes de FEL
                </router-link>

                <router-link class="btn btn-info" :to="{ name: 'cxc-cargos' }">
                  Ver Todos los Cargos
                  <i class="fa fa-link"></i>
                </router-link>
                <hr />
                <div>
                  <a
                    id="color_on_hover"
                    @click="refreshCurrent()"
                    class="dropdown-item"
                  >
                    <i class="fas fa-sync"></i> Actualizar Info.
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-3">
          <div class="element-wrapper" style="padding-bottom: 0.5rem">
            <div class="element-box" style="padding-bottom: 3.5rem">
              <div class="form-group text-right">
                <h6 class="text-center text-success">Información General</h6>
                <hr />
                <div class="form-group text-right">
                  <small>
                    <label class="font-weight-bold">Fecha Creación</label>
                  </small>
                  <h5 class="text-success text-right">
                    <span>{{ current.fecha }}</span>
                  </h5>
                </div>
                <small>
                  <label class="font-weight-bold">Valor Total</label>
                </small>
                <h4 class="text-right">
                  <span class="text-success">Q {{ current.total }}</span>
                </h4>
              </div>

              <div class="form-group text-right">
                <small>
                  <label class="font-weight-bold">Total Aplicado</label>
                </small>
                <h4 class="text-right">
                  <span class="text-success"
                    >Q {{ current.total_aplicado }}</span
                  >
                </h4>
              </div>

              <div class="form-group text-right">
                <small>
                  <label class="font-weight-bold">Saldo Pendiente</label>
                </small>
                <h4 class="text-right">
                  <span class="text-danger"
                    >Q {{ current.total_pendiente }}</span
                  >
                </h4>
              </div>
              <div class="form-group text-right">
                <button
                  @click="abirModalLog()"
                  class="btn btn-sm btn-primary btn-block"
                >
                  Ver Log <i class="fas fa-history"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="element-wrapper">
            <div class="element-box">
              <h5 class="form-header text-success font-weight-bold">Detalle</h5>
              <div class="table-responsive" v-if="current.id != null">
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Producto</th>
                      <th class="text-center">Unidades</th>
                      <th class="text-center">Unidad de Medida</th>
                      <th class="text-center">Peso</th>
                      <th class="text-center">Precio</th>
                      <th class="text-center">Descuento</th>
                      <th class="text-center">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="detalle in current.cxccargod_set"
                      v-bind:key="detalle.id"
                    >
                      <td>
                        {{ detalle.producto.sku }} -
                        {{ detalle.descripcion }}
                      </td>
                      <td
                        class="text-right bolder nowrap"
                        style="font-weight: 500"
                      >
                        <span> {{ detalle.cantidad_um }}</span>
                      </td>
                      <td
                        class="text-lefth bolder nowrap"
                        style="font-weight: 500"
                      >
                        <span> {{ detalle.unidad_medida.nombre }}</span>
                      </td>
                      <td
                        class="text-right bolder nowrap"
                        style="font-weight: 500"
                      >
                        <span> {{ detalle.peso }}</span>
                      </td>
                      <td
                        class="text-right bolder nowrap"
                        style="font-weight: 500"
                      >
                        <span> {{ detalle.precio }}</span>
                      </td>
                      <td
                        class="text-right bolder nowrap"
                        style="font-weight: 500"
                      >
                        <span> {{ detalle.descuento }}</span>
                      </td>
                      <td
                        class="text-right bolder nowrap"
                        style="font-weight: 500"
                      >
                        <span> {{ detalle.total }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class>
                  <button
                    type="button"
                    class="btn btn-sm btn-secondary"
                    @click="showModalAddDetail"
                    v-if="current.estado == 'A'"
                  >
                    <i class="fa fa-plus"></i>
                    Agregar Producto
                  </button>
                </div>
                <br />
                <div></div>
                <br />
                <h5 class="form-header text-success font-weight-bold">
                  Aplicación o Pagos
                </h5>
                <div class="table-responsive" v-if="current.id != null">
                  <table class="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>Serie</th>
                        <th>Número</th>
                        <th class="text-center">Cuenta Bancaria</th>
                        <th class="text-center">Fecha</th>
                        <th class="text-center">Total</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr
                        v-for="detalle in current.cxcaplicacionabonocargo_set"
                        v-bind:key="detalle.id"
                      >
                        <td>{{ detalle.abono_e.abono_serie }}</td>
                        <td>{{ detalle.abono_e.numero }}</td>
                        <td>{{ detalle.abono_e.cuenta_bancaria }}</td>
                        <td>{{ detalle.abono_e.fecha }}</td>
                        <td>{{ detalle.valor_total }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <br />
                <h5 class="form-header text-success font-weight-bold">
                  Contabilización
                </h5>
                <div class="table-responsive">
                  <!-------------------- Tabla de REsultados -------------------->
                  <table class="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>Cuenta Contable</th>
                        <th>Centro Costo</th>
                        <th>Descripción</th>
                        <th class="text-center">Fecha</th>
                        <th class="text-center">Cargo</th>
                        <th class="text-center">Abono</th>
                        <th class="text-center">Opciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="detalle in current.cxccargocontab_set"
                        v-bind:key="detalle.id"
                      >
                        <td>
                          {{ detalle.cuenta_contable.id }} -
                          {{ detalle.cuenta_contable.nombre }}
                        </td>
                        <td>
                          {{ detalle.centro_costo.id }} -
                          {{ detalle.centro_costo.nombre }}
                        </td>
                        <td>
                          {{ detalle.descripcion }}
                        </td>
                        <td>{{ detalle.fecha }}</td>
                        <td class="text-right">Q{{ detalle.cargo }}</td>
                        <td class="text-right">Q{{ detalle.abono }}</td>
                        <td class="text-center">
                          <button
                            :disabled="current.contable == true"
                            @click="eliminarContabilicacion(detalle)"
                            class="btn btn-sm btn-danger"
                          >
                            <i class="fa fa-trash-alt"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot
                      v-bind:class="{
                        'table-info':
                          current.total_cargo_contable ==
                          current.total_abono_contable,
                        'table-danger':
                          current.total_cargo_contable !=
                          current.total_abono_contable,
                      }"
                    >
                      <tr>
                        <td colspan="4">Total Contable</td>
                        <td class="text-right">
                          Q {{ current.total_cargo_contable }}
                        </td>
                        <td class="text-right">
                          Q {{ current.total_abono_contable }}
                        </td>
                        <td colspan="3"></td>
                      </tr>
                    </tfoot>
                  </table>
                  <!-------------------- END - Basic Table -------------------->
                </div>
                <br />
                <h6>Agregar Contabilización</h6>
                <div
                  style="
                    background-color: rgba(238, 237, 228, 1);
                    border-radius: 10px;
                  "
                  class="row"
                >
                  <div class="col-3">
                    <CuentaContableSelectComponent
                      :propname="'cuenta_contable'"
                      :label="'Cuenta Contable'"
                      :current="currentContable"
                    />
                  </div>
                  <div class="col-2">
                    <CentroCostoSelectComponent :current="currentContable" />
                  </div>

                  <div class="col-2">
                    <label>Descripción</label>
                    <textarea
                      :disabled="current.contable == true"
                      class="form-control"
                      v-model="currentContable.descripcion"
                      rows="1"
                    ></textarea>
                    <small
                      class="text-danger"
                      v-if="
                        currentContable.errors &&
                        currentContable.errors.descripcion
                      "
                      >{{ currentContable.errors.descripcion }}</small
                    >
                  </div>
                  <div class="col-2">
                    <label>Cant. cargo</label>
                    <input
                      :disabled="current.contable == true"
                      v-model="currentContable.cargo"
                      type="text"
                      class="form-control"
                    />
                    <small
                      class="text-danger"
                      v-if="
                        currentContable.errors && currentContable.errors.cargo
                      "
                      >{{ currentContable.errors.cargo }}</small
                    >
                  </div>
                  <div class="col-2">
                    <label>Cant. abono</label>
                    <input
                      :disabled="current.contable == true"
                      v-model="currentContable.abono"
                      type="text"
                      class="form-control"
                    />
                    <small
                      class="text-danger"
                      v-if="
                        currentContable.errors && currentContable.errors.abono
                      "
                      >{{ currentContable.errors.abono }}</small
                    >
                  </div>
                  <div>
                    <br />
                    <button
                      type="button"
                      class="btn btn-sm btn-success"
                      :disabled="current.contable == true"
                      @click="agregarContabilizacion()"
                    >
                      <i class="fa fa-plus"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm btn-dark"
                      :disabled="current.contable == true"
                      @click="resetDataModalContable()"
                    >
                      <i class="fa fa-sync"></i>
                    </button>
                  </div>
                </div>
                <br />
                <div class>
                  <button
                    type="button"
                    class="btn btn-sm btn-secondary"
                    @click="showModalAplicacionPago"
                    v-if="current.estado == 'A'"
                  >
                    <i class="fa fa-plus"></i>
                    Agregar Aplicacion o Pago
                  </button>
                </div>
                <!-------------------- END - Basic Table -------------------->
              </div>
              <div class="form-buttons-w">
                <button
                  class="btn btn-md btn-success"
                  v-if="!current.id"
                  type="submit"
                >
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAdddevolucion"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Devoluciones a Clientes</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-sm-12 col-md-12">
                  <div class="form-group">
                    <label>Caja</label>
                    <select
                      class="form-control"
                      autofocus="autofocus"
                      v-model="currentDetalle.caja"
                    >
                      <option v-for="(c, key) in caja" :value="c.id" :key="key">
                        Caja: {{ c.caja }} - Tienda {{ c.tienda.nombre }}
                      </option>
                    </select>
                    <small
                      v-if="errors && errors.caja"
                      class="form-text text-danger"
                      >{{ errors.caja[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Observación</label>
                    <textarea
                      v-model="currentDetalle.observacion"
                      class="form-control"
                      type="text"
                    />
                    <small
                      v-if="errors && errors.observacion"
                      class="form-text text-danger"
                      >{{ errors.observacion[0] }}</small
                    >
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-primary"
              @click="guardarDevolucion()"
              type="button"
            >
              Agregar
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModalDetalle"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="current.id">
      <div
        class="modal fade"
        id="modalLog"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modalLog"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal-lg"
          style="width: 1000px"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Historial de Certificacion FEL
                <i class="fas fa-history"></i>
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div
              style="overflow-y: scroll; max-height: 610px"
              class="modal-body"
            >
              <table class="table table-striped table-bordered table-hover">
                <thead>
                  <tr>
                    <th class="text-left">Tipo de documento</th>
                    <th class="text-left">Respuesta</th>
                    <th class="text-left">¿Hubo error?</th>
                    <th class="text-left">XML</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="det in logs" v-bind:key="det.id">
                    <td
                      style="color: blue; width: 30px"
                      class="text-center font-weight-bold"
                    >
                      {{ det.tipo_documento }}
                    </td>
                    <td class="text-left" style="width: 100px">
                      {{ det.respuesta }}
                    </td>
                    <td
                      class="text-center font-weight-bold"
                      style="width: 50px"
                    >
                      <span class="text-danger" v-if="det.es_error == true"
                        >SI</span
                      >
                      <span class="text-success" v-if="det.es_error == false"
                        >NO</span
                      >
                    </td>
                    <td>
                      {{ det.xml_string }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProductosService from "@/services/catalogos/ProductosService";
import CargosService from "@/services/cxc/CargosService";
import Notifications from "@/notifications/notifications";
import AbonosService from "@/services/cxc/AbonosService";
import DevolucionesService from "@/services/inventario/DevolucionesService";
import CuentaContableSelectComponent from "@/components/commons/CuentaContableSelectComponent";
import CentroCostoSelectComponent from "@/components/commons/CentroCostoSelectComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    CuentaContableSelectComponent,
    CentroCostoSelectComponent,
  },
  computed: {
    descripcionCorta() {
      return this.log_error.substring(0, 100) + "...";
    },
    ...mapGetters({
      caja: "cargos/caja",
      tiendas: "catalogos/tiendas",
      clientes: "catalogos/clientes",
      centrocosto: "catalogos/centro_costo",
      cuenta: "conta/cuenta_contable",
    }),
  },
  data() {
    return {
      current: {
        errors: [],
        valor_impuesto: 12,
        id: null,
        estado_str: null,
        tienda: "",
        estado: "A",
        estado_str: "",
        valor_total: 0,
        cliente_nombre: "",
        cliente_nit: "",
        numero: "",
        cxccargod_set: [],
        cxccargocontab_set: [],
        cxcaplicacionabonocargo_set: [],
        prod_unimed: "",
        prod_sku: "",
        prod_cantidad: "",
      },
      mostrarCompleto: false,
      jsonString: "",
      baseApiUrl: "",
      currentContable: {
        cuenta_contable: null,
        abono: 0,
        cargo: 0,
        centro_costo: null,
        descripcion: null,
        errors: [],
      },
      factura: "",
      series: [],
      logs: [],
      log_error: "",
      abonos: [],
      productos: [],
      options: [],
      errors: [],
      abono_e: "",
      producto_lote: [],
      currentDetalle: {
        cantidad: 0,
        posicion: 0,
        producto: "",
        codigo_lote: 0,
        productolote_set: [],
        productounidadmedida_set: [],
        errors: [],
        valor_total: "",
        valor_impuesto: 12,
      },
    };
  },
  mounted() {
    let self = this;
    if (this.$route.params.id) {
      self.refreshCurrent();
    }
    self.baseApiUrl = process.env.VUE_APP_ROOT_API;
    if (this.$route.params.id) {
      self.factura = this.$route.params.id.replace(/-/g, "");
    }
    
    //self.refreshCentroCosto();
    //self.refreshCuentaContable();
  },
  methods: {
    RefreshData() {
      let self = this;
      DynamicService.postAction(
        "cxc",
        "cargos",
        self.current.id,
        "api_log_oasis"
      ).then((response) => {
        self.logs = response.data;
        self.log_error = self.logs.find((obj) => obj.es_error === true);
        self.log_error = self.log_error.respuesta;
      });
    },
    abirModalLog() {
      let self = this;
      self.RefreshData();
      $("#modalLog").modal("show");
    },
    cerrerContabilizacion() {
      let self = this;
      Notifications.alert.confirm(
        "Cerrar Contabilización",
        "esta seguro(a)",
        "",
        function () {
          DynamicService.postAction(
            "cxc",
            "cargos",
            self.current.id,
            "cerrar_contabilizacion"
          )
            .then((response) => {
              Notifications.alert.success(
                "Cerrar Contabilización",
                "Realizado Exitosamente"
              );
              self.refreshCurrent();
            })
            .catch((errors) => {
              Notifications.alert.error(
                "Cerrar Contabilizacíon",
                errors.response.data.detail
              );
            });
        }
      );
    },
    eliminarContabilicacion(det) {
      DynamicService.postAction(
        "cxc",
        "cargos",
        this.current.id,
        "eliminar_contabilizacion",
        det
      )
        .then((response) => {
          Notifications.alert.success(
            "Eliminar Contabilización",
            "Realizado Exitosamente"
          );
          this.refreshCurrent();
        })
        .catch((errors) => {
          Notifications.alert.error(
            "Eliminar Contabilizacíon",
            errors.response.data.detail
          );
        });
    },
    resetDataModalContable() {
      this.currentContable.cuenta_contable = "";
      this.currentContable.abono = 0;
      this.currentContable.cargo = 0;
      this.currentContable.centro_costo = "";
      this.currentContable.descripcion = "";
      this.currentContable.errors = [];
    },
    agregarContabilizacion() {
      let det = this.currentContable;
      if (det.cuenta_contable) {
        det.cuenta_contable = det.cuenta_contable.id;
      }
      DynamicService.postAction(
        "cxc",
        "cargos",
        this.current.id,
        "agregar_contabilizacion",
        this.currentContable
      )
        .then((response) => {
          Notifications.alert.success(
            "Agregar Contabilización",
            "Realizado Exitosamente"
          );
          this.refreshCurrent();
          this.resetDataModalContable();
        })
        .catch((errors) => {
          this.currentContable.errors = errors.response.data;
          Notifications.alert.error(
            "Agregar Contabilizacíon",
            errors.response.data.detail
          );
        });
    },
    refreshCaja() {
      let self = this;
      self.$store.dispatch("cargos/caja", {
        activa: true,
        quitar_paginacion: true,
      });
    },

    rowClick() {
      let self = this;
      if (self.caja.length == 0) {
        self.refreshCaja();
      }
      $("#modalAdddevolucion").modal();
    },

    showModalAdddevolucionNew(detalle) {
      let self = this;
      $("#modalAdddevolucionNew").modal();
    },

    guardarDevolucion() {
      let self = this;
      let currentDetalle = Object.assign({}, self.currentDetalle);
      currentDetalle.cargo_id = self.current.id;
      DevolucionesService.save(currentDetalle)
        .then((response) => {
          self.$refs.cerrarModalDetalle.click();
          self.$router.push({
            name: "inventario-devoluciones-editar",
            params: { id: response.data.id },
          });
          self.refreshCurrent();
        })
        .catch((error) => {
          self.errors = error.response.data;
          if (self.errors.cargo_e) {
            Notifications.alert.error(
              "Generar devolución",
              self.errors.cargo_e
            );
          }
          if (self.errors.devolucion_cliente) {
            Notifications.alert.error(
              "Generar devolución",
              self.errors.devolucion_cliente
            );
          }
        });
    },

    setSelected(value) {
      let self = this;
      ProductosService.getById(value.sku).then((res) => {
        self.currentDetalle.productounidadmedida_set =
          res.data.productounidadmedida_set;
      });
    },
    refreshCurrent() {
      let self = this;
      CargosService.getById(this.$route.params.id).then((response) => {
        self.current = response.data;
        self.current.cargo_serie = response.data.cargo_serie.serie;
        self.current.total = response.data.valor_total;
        self.current.despacho = response.data.vendedor.name;
        self.current.vendedor = response.data.vendedor.id;
        self.current.local = response.data.tienda.nombre;
        self.current.tienda = response.data.tienda.codigo;
        self.current.fecha_creacion = moment(
          self.current.fecha_creacion
        ).format("DD/MM/YYYY hh:mm:s a");
        self.current.errors = [];
        self.RefreshData();
      });
    },
    refreshCentroCosto() {
      let self = this;
      self.$store.dispatch("catalogos/centro_costo", {
        activa: true,
        quitar_paginacion: true,
      });
    },
    refreshCuentaContable() {
      let self = this;
      self.$store.dispatch("conta/cuenta_contable", {
        activa: true,
        quitar_paginacion: true,
      });
    },
    guardar(e) {
      let self = this;
      e.preventDefault();
      var current = Object.assign({}, self.current);
      delete current.image;
      if (this.$route.params.id) {
        current.pk = this.$route.params.id;
        delete current.id;
      }
      CargosService.save(current)
        .then((res) => {
          self.current = res.data;
          self.current.id;
          self.current.errors = {};
          Notifications.alert.success(
            "Cargo",
            "Se ha guardado la Información."
          );
          self.$router.push({
            name: "cxc-cargos-editar",
            params: { id: self.current.id },
          });
        })
        .catch((error) => {
          Vue.nextTick(function () {
            self.current.errors = Object.assign({}, error.response.data);
          });
        });
    },
    aplicar(e) {
      e.preventDefault();
      let self = this;
      this.current.cliente_nombre = self.current.cliente_nit.nombre;
      this.current.cliente_direccion = self.current.cliente_nit.direccion;
      this.current.cliente_nit = self.current.cliente_nit.nit;
    },

    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },

    onSearchProducto(search, loading) {
      loading(true);
      this.searchProducto(loading, search, this);
    },

    onSearchAbono(search, loading) {
      loading(true);
      this.searchAbono(loading, search, this);
    },

    searchAbono: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      AbonosService.fetch({
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.abonos = res.data;
        loading(false);
      });
    }, 350),

    searchProducto: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      ProductosService.fetch({
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.productos = res.data;
        loading(false);
      });
    }, 350),
    showModalAddDetail() {
      let self = this;
      ProductosService.fetch({
        page: 1,
        activo: true,
        permitir_compra: true,
      }).then((res) => {
        self.productos = res.data.results;
        $("#modalAddDetailReqTraslado").modal();
      });
    },

    showModalAplicacionPago() {
      let self = this;
      AbonosService.fetch({
        page: 1,
        activo: true,
        permitir_compra: true,
        estado: "B",
      }).then((res) => {
        self.abonos = res.data.results;
        $("#modalAgregarAplicacion").modal();
      });
    },
    agregaConta() {
      let self = this;
      let det = Object.assign({}, self.current);
      CargosService.agregar_contabilizacion(self.current.id, {
        fecha: det.fecha,
        descripcion: det.descripcion,
        centro_costo: det.centro_costo,
        cuenta_contable: det.cuenta_contable,
        cargo: det.cargo,
        abono: det.abono,
      })
        .then((response) => {
          Notifications.alert.success(
            "Listo",
            "Se ha Agregado la contabilizacion."
          );
          self.refreshCurrent();
          self.$refs.cerrarModal.click();
          self.$router.push({
            name: "cxc-cargos-editar",
            params: { id: self.current.id },
          });
        })
        .catch((error) => {
          self.current.errors = error.response.data;
        });
    },

    agregaDetalle() {
      let self = this;
      let det = Object.assign({}, self.current);
      CargosService.agregar_detalle(self.current.id, {
        producto: det.prod_sku.sku,
        cantidad_um: det.prod_cantidad,
        unidad_medida: det.prod_unimed,
      })
        .then((response) => {
          Notifications.alert.success("Cargos", "Se ha Agregado el Producto.");
          self.refreshCurrent();
          self.$refs.cerrarModalDetalle.click();
          self.$router.push({
            name: "cxc-cargos-editar",
            params: { id: self.current.id },
          });
        })
        .catch((error) => {
          self.currentDetalle.errors = error.response.data;
        });
    },

    agregaAbono() {
      let self = this;
      let det = Object.assign({}, self.current);
      CargosService.aplicar_abono(self.current.id, {
        valor_total: det.valor_total,
        abono_e: det.abono.id,
      })
        .then((response) => {
          Notifications.alert.success("Cargos", "Se ha Aplicado el Abono.");
          self.refreshCurrent();
          self.$refs.cerrarModalAbono.click();
          self.$router.push({
            name: "cxc-cargos-editar",
            params: { id: self.current.id },
          });
        })
        .catch((error) => {
          self.current.errors = error.response.data;
        });
    },

    eliminarDetalle(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Cargos",
        "¿Esta seguro de eliminar el Producto?",
        "Si Eliminar",
        function () {
          CargosService.eliminar_detalle(self.current.id, {
            id: detalle.id,
          })
            .then((response) => {
              Notifications.alert.success(
                "Cargos",
                "Se ha eliminado la Información."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              self.current.errors = error.response.data;
            });
        }
      );
    },
    eliminarAplicacion(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Cargos",
        "¿Esta seguro de eliminar el registro?",
        "Si Eliminar",
        function () {
          CargosService.eliminar_abono_aplicado(self.current.id, {
            id: detalle.id,
          })
            .then((response) => {
              Notifications.alert.success(
                "Cargos",
                "Se ha eliminado la Aplicación."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              self.current.errors = error.response.data;
            });
        }
      );
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Cargos",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          CargosService.abrir(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Cargos",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Abrir Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Cargos",
        "Desea cerrar la transacción?",
        "Si Abrir",
        function () {
          CargosService.cerrar(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Cargos",
                "Se ha cerrado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Cerrar Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    imprimir() {
      let self = this;
      Notifications.alert.confirm(
        "Imprimir Cargo",
        "Desea imprimir la transacción?",
        "Si Imprimir",
        function () {
          CargosService.imprimir(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Cargos",
                "Se ha impreso la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Error al Imprimir Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    ImprimirPND() {
      let op = self.current.pedido_e.id.replace(/-/g, "");
      baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=cxc/pedidos/Devolucion_ProductoND.jrxml&Id=${op}`
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Cargos",
        "Desea Anular la transacción?",
        "Si Anular",
        function () {
          CargosService.anular(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Cargos",
                "Se ha anulado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Anular Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    fel() {
      let self = this;
      Notifications.alert.confirm(
        "Cargos",
        "Desea enviar el numero Fel?",
        "Si, Enviar Fel",
        function () {
          CargosService.enviar_fel(self.current.id)
            .then((response) => {
              self.jsonString = response.data;
              self.refreshCurrent();
              if (self.jsonString) {
                var obj = JSON.parse(self.jsonString);
                var resultado = obj.descripcion_errores[0];
                console.log(resultado); // output: false
              }
              if (self.jsonString) {
                Notifications.alert.error(
                  "Error al certificar factura",
                  self.jsonString
                );
                return;
              }
              Notifications.alert.success(
                "Cargos",
                "Se ha enviado el numero fel."
              );
            })
            .catch((error) => {
              Notifications.alert.error(
                "Enviar Fel",
                error.response.data.detail
              );
            });
        }
      );
    },
    onSearchCliente(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      vm.$store.dispatch("catalogos/clientes", {
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      });
      loading(false);
    }, 350),
  },
};
</script>

<style>
#color_on_hover {
  text-decoration: none;
}

#color_on_hover {
  background: linear-gradient(
      to right,
      rgb(178, 196, 196),
      rgba(178, 196, 196, 1)
    ),
    linear-gradient(
      to right,
      rgba(255, 0, 0, 1),
      rgba(255, 0, 180, 1),
      rgba(0, 100, 200, 1)
    );
  background-size: 100% 3px, 0 3px;
  background-position: 100% 100%, 0 100%;
  background-repeat: no-repeat;
  transition: background-size 150ms;
}

#color_on_hover:active {
  background-size: 0 3px, 100% 3px;
}
</style>